"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// extracted into a separate module so it's easier to mock with Jest
function getWindowHeight() {
  return window.innerHeight;
}

var _default = getWindowHeight;
exports.default = _default;